/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registrationOptions: {
      scope: process.env.BASE_URL,
    },
    ready () {
      Logger.debug(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      Logger.debug('Service worker has been registered.')
    },
    cached () {
      Logger.debug('Content has been cached for offline use.')
    },
    updatefound () {
      // new content clear cache so user gets the new version
      Logger.debug('New content is downloading.')
    },
    updated (registration) {
      Logger.debug('New content is available; please refresh.')
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline () {
      Logger.debug('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      Logger.error('Error during service worker registration:', error)
    }
  })
}
